// F3.5 — visibilidade condicional de campos. Cada campo pode ter
// field.visible_if = { field: <key-do-campo-fonte>, operator, value }.
// Operadores: equals | not_equals | includes | filled. Sem regra = sempre visível.
const isBlank = v =>
  v == null || v === '' || (Array.isArray(v) && v.length === 0);

export const isFieldVisible = (field, values = {}) => {
  const rule = field && field.visible_if;
  if (!rule || !rule.field || !rule.operator) return true;

  const source = values[rule.field];
  const target = rule.value;
  const asText = v => String(v == null ? '' : v);

  switch (rule.operator) {
    case 'filled':
      return !isBlank(source);
    case 'equals':
      return Array.isArray(source)
        ? source.includes(target)
        : asText(source) === asText(target);
    case 'not_equals':
      return Array.isArray(source)
        ? !source.includes(target)
        : asText(source) !== asText(target);
    case 'includes':
      return Array.isArray(source)
        ? source.includes(target)
        : asText(source).includes(asText(target));
    default:
      return true;
  }
};

// Filtra uma lista de campos pela visibilidade dada as respostas atuais.
export const visibleFieldsFor = (fields = [], values = {}) =>
  fields.filter(field => isFieldVisible(field, values));
